export default __webpack_public_path__ + "static/media/contact-light.b043be0a.svg";